/** Traductions indicateur hors ligne (FR / AR) */
export const offlineIndicatorFr = {
  message: 'Pas de connexion Internet — mode navigateur uniquement (dev)'
};

export const offlineIndicatorAr = {
  message: 'لا يوجد اتصال بالإنترنت — وضع المتصفح للتطوير فقط'
};
